"use strict";

exports.__esModule = true;
exports.isSrc = isSrc;
require("core-js/modules/es.regexp.exec.js");
/**
 * Is image source
 */
function isSrc(url) {
  return /^(https?:)?\/\/|data:image|\.(jpg|png|jpeg|gif|webp|bmp)$/.test((url || '').toLowerCase());
}